import { Typography } from "@mui/material";

function Contact() {
  return <Typography>Contact Us page</Typography>;
}
export default Contact;